import { Modal } from 'react-bootstrap-v5';
import { IMemoriaCalculo } from '../../interfaces/IRelatorio';
import { Formatter, limitarTexto } from './Relatorio';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import { useState } from 'react';



function RelatorioModalMemoriaCalculo({ toggleModalMemoriaCalculo, show, idAlgoritimoConstancia, memoriasCalculo }: { toggleModalMemoriaCalculo: () => void, show: boolean, idAlgoritimoConstancia: number, memoriasCalculo: IMemoriaCalculo[] }) {

    let itemAnalise: any = {};

    let options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
            },
            title: {
                display: true,
                text: memoriasCalculo.length ? memoriasCalculo[0].historico : undefined,
            },
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };

    let labels: any[] = [];
    let dados: any[] = [];
    let pointBackgroundColor: any[] = [];

    memoriasCalculo.map((memoria) => {
        let data = moment(memoria.dataLancamento).format("MM/YYYY");

        labels.push(data);
        dados.push(memoria.valor);

        if (memoria.status === "EMCONFORMIDADE") {
            pointBackgroundColor.push("#00e500");
        } else {
            pointBackgroundColor.push("#FF4500");
        }

        if (memoria.id === idAlgoritimoConstancia) {
            itemAnalise = memoria;
        }
    });

    let data = {
        labels,
        datasets: [
            {
                label: memoriasCalculo.length ? memoriasCalculo[0].descricaoCodigoContabil : undefined,
                data: dados,
                borderColor: '#005E96',
                backgroundColor: '#005E96',
                pointBackgroundColor: pointBackgroundColor
            }
        ],
    };

    return <Modal size='lg' centered={true} show={show} onHide={toggleModalMemoriaCalculo}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">Memória de cálculo</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={toggleModalMemoriaCalculo} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body">
                <div className="col-md-12" style={{ display: 'flex', padding: '5px' }}>
                    <div className="col-md-12" style={{ border: '1px solid #DFDFDF', borderRadius: '5px', marginRight: '3px', padding: '10px 15px' }}>
                        <label style={{ color: '#474A71', fontSize: '16px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>Registro do ECD</label>
                        {
                            <p>
                                Conta contábil: {itemAnalise.contaContabil} - {itemAnalise.descricaoCodigoContabil}
                                <br></br>
                                Histórico: {itemAnalise.historico}
                                <br></br>
                                Tipo de Lançamento: {itemAnalise.tipo}    Data de Lançamento:  {moment(itemAnalise.dataLancamento).format("DD/MM/YYYY")}
                            </p>
                        }
                    </div>
                </div>


                <div className="col-md-12" style={{ display: 'flex', padding: '5px' }}>
                    <div className="col-md-12" style={{ border: '1px solid #DFDFDF', borderRadius: '5px', marginRight: '3px', padding: '10px 15px' }}>
                        <Line options={options} data={data} />
                    </div>
                </div>

            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button onClick={toggleModalMemoriaCalculo} type="button" className="btn btn-modal-cancelar me-5"> FECHAR </button>
            </div>
        </div>
    </Modal>
}

export default RelatorioModalMemoriaCalculo;

